'use strict';

require("core-js/modules/es6.regexp.constructor");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.array.map");

exports.__esModule = true;

var _core = require('@emotion/core');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = require('../../../utils');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return 'You have tried to stringify object returned from `css` function. It isn\'t supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).';
}
/** @jsx jsx */


var highlightedStyling = process.env.NODE_ENV === 'production' ? {
  name: '12fugvv-highlightedStyling',
  styles: 'overflow:hidden;text-overflow:ellipsis;white-space:nowrap;.highlight{font-weight:600;padding:0;background-color:transparent;color:inherit;};label:highlightedStyling;'
} : {
  name: '12fugvv-highlightedStyling',
  styles: 'overflow:hidden;text-overflow:ellipsis;white-space:nowrap;.highlight{font-weight:600;padding:0;background-color:transparent;color:inherit;};label:highlightedStyling;',
  map: '/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL3NlYXJjaC9hZGRvbnMvSGlnaGxpZ2h0LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU04QiIsImZpbGUiOiIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9zZWFyY2gvYWRkb25zL0hpZ2hsaWdodC5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgY3NzLCBqc3ggfSBmcm9tICdAZW1vdGlvbi9jb3JlJztcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcyc7XG5cbmltcG9ydCB7IGVzY2FwZVJlZ0V4cCB9IGZyb20gJy4uLy4uLy4uL3V0aWxzJztcblxuY29uc3QgaGlnaGxpZ2h0ZWRTdHlsaW5nID0gY3NzYFxuXHRvdmVyZmxvdzogaGlkZGVuO1xuXHR0ZXh0LW92ZXJmbG93OiBlbGxpcHNpcztcblx0d2hpdGUtc3BhY2U6IG5vd3JhcDtcblx0LmhpZ2hsaWdodCB7XG5cdFx0Zm9udC13ZWlnaHQ6IDYwMDtcblx0XHRwYWRkaW5nOiAwO1xuXHRcdGJhY2tncm91bmQtY29sb3I6IHRyYW5zcGFyZW50O1xuXHRcdGNvbG9yOiBpbmhlcml0O1xuXHR9XG5gO1xuXG5jb25zdCBIaWdobGlnaHQgPSAocHJvcHMpID0+IHtcblx0Y29uc3QgeyB0ZXh0VG9IaWdobGlnaHQsIHNlYXJjaFdvcmRzLCBhdXRvRXNjYXBlIH0gPSBwcm9wcztcblx0Y29uc3QgbW9kU2VhcmNoV29yZHMgPSBzZWFyY2hXb3Jkcy5tYXAod29yZCA9PiAoYXV0b0VzY2FwZSA/IGVzY2FwZVJlZ0V4cCh3b3JkKSA6IHdvcmQpKTtcblx0Y29uc3Qgc3RyaW5nVG9SZXBsYWNlID0gbW9kU2VhcmNoV29yZHMuam9pbignfCcpO1xuXHRyZXR1cm4gKFxuXHRcdDxkaXZcblx0XHRcdGNzcz17aGlnaGxpZ2h0ZWRTdHlsaW5nfVxuXHRcdFx0ZGFuZ2Vyb3VzbHlTZXRJbm5lckhUTUw9e3tcblx0XHRcdFx0X19odG1sOiB0ZXh0VG9IaWdobGlnaHQucmVwbGFjZShcblx0XHRcdFx0XHRuZXcgUmVnRXhwKHN0cmluZ1RvUmVwbGFjZSwgJ2lnJyksXG5cdFx0XHRcdFx0bWF0Y2hlZCA9PiBgPG1hcmsgY2xhc3M9XCJoaWdobGlnaHRcIj4ke21hdGNoZWR9PC9tYXJrPmAsXG5cdFx0XHRcdCksXG5cdFx0XHR9fVxuXHRcdC8+XG5cdCk7XG59O1xuXG5IaWdobGlnaHQucHJvcFR5cGVzID0ge1xuXHRzZWFyY2hXb3JkczogUHJvcFR5cGVzLmFycmF5T2YoUHJvcFR5cGVzLnN0cmluZyksXG5cdHRleHRUb0hpZ2hsaWdodDogUHJvcFR5cGVzLnN0cmluZyxcblx0YXV0b0VzY2FwZTogUHJvcFR5cGVzLmJvb2wsXG59O1xuXG5IaWdobGlnaHQuZGVmYXVsdFByb3BzID0ge1xuXHRzZWFyY2hXb3JkczogW10sXG5cdHRleHRUb0hpZ2hsaWdodDogJycsXG5cdGF1dG9Fc2NhcGU6IGZhbHNlLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgSGlnaGxpZ2h0O1xuIl19 */',
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var Highlight = function Highlight(props) {
  var textToHighlight = props.textToHighlight,
      searchWords = props.searchWords,
      autoEscape = props.autoEscape;
  var modSearchWords = searchWords.map(function (word) {
    return autoEscape ? (0, _utils.escapeRegExp)(word) : word;
  });
  var stringToReplace = modSearchWords.join('|');
  return (0, _core.jsx)('div', {
    css: highlightedStyling,
    dangerouslySetInnerHTML: {
      __html: textToHighlight.replace(new RegExp(stringToReplace, 'ig'), function (matched) {
        return '<mark class="highlight">' + matched + '</mark>';
      })
    }
  });
};

Highlight.propTypes = {
  searchWords: _propTypes2["default"].arrayOf(_propTypes2["default"].string),
  textToHighlight: _propTypes2["default"].string,
  autoEscape: _propTypes2["default"].bool
};
Highlight.defaultProps = {
  searchWords: [],
  textToHighlight: '',
  autoEscape: false
};
exports["default"] = Highlight;